import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js';
import { IQuarterlyStatistics } from 'src/app/reports/reports-models';
import { newId } from 'src/app/shared/utilities';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
  selector: 'app-quarters-totals',
  templateUrl: './quarters-totals.component.html',
  styleUrls: ['../charts.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule]
})
export class QuartersTotalsComponent implements OnChanges, AfterViewInit {
  @Input()
  data: IQuarterlyStatistics[];
  @Input()
  textColor: string;
  @Input()
  fontOptions: any;

  private readonly _canvasId = `quartersCaseRegistrationCanvas${newId()}`;
  get canvasId() { return this._canvasId; }
  lineChartCanvas: HTMLCanvasElement;
  lineChart;
  color1 = this.utilsService.readCssStyleProperty('--clr-svea-2');
  color2 = this.utilsService.readCssStyleProperty('--clr-svea-1');

  graph: any = {
    labels: [],
    datasets: [
      {
        type: 'bar',
        data: [],
        backgroundColor: this.color1,
        borderColor: this.color1,
        borderWidth: 1,
        yAxisID: 'y1',
        order: 2
      },
      {
        type: 'line',
        data: [],
        backgroundColor: this.color2,
        borderColor: this.color2,
        borderWidth: 1,
        yAxisID: 'y2',
        order: 1
      }
    ]
  }

  options: any;

  constructor(
    private utilsService: UtilsService,
    private translateService: TranslateService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.previousValue) {
      this.lineChart.destroy();
      this.buildChart();
    }
  }

  ngAfterViewInit(): void {
    this.lineChartCanvas = document.getElementById(this.canvasId) as HTMLCanvasElement;
    this.buildChart();
  }

  private buildChart() {
    this.options = {
      plugins: {
        legend: {
          labels: {
            color: this.textColor,
            font: this.fontOptions
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          ticks: {
            font: this.fontOptions,
            color: this.textColor
          },
          offset: true
        },
        y1: {
          display: true,
          position: 'left',
          grid: {
            display: false
          },
          ticks: {
            font: this.fontOptions,
            color: this.textColor
          },
          offset: true,
          stacked: false
        },
        y2: {
          display: true,
          position: 'right',
          ticks: {
            font: this.fontOptions,
            color: this.textColor
          },
          grid: {
            display: false
          },
          offset: true,
          stacked: false
        },
      },
      responsive: true,
      maintainAspectRatio: false,
      clamp: true
    }

    this.graph.labels = this.data.map(x => x.quarter).reverse();
    this.graph.datasets[0].label = this.translateService.instant('Reports.PortfolioReport.ReceivedCapital');
    this.graph.datasets[1].label = this.translateService.instant('Reports.PortfolioReport.CaseVolume');
    this.graph.datasets[0].data = this.graph.labels.map(x =>  this.data.filter(y => y.quarter == x)[0].totalAmountCapital);
    this.graph.datasets[1].data = this.graph.labels.map(x => this.data.filter(y => y.quarter == x)[0].numberOfRegisteredCases);

    this.lineChart = new Chart(this.lineChartCanvas, {
      type: 'line',
      data: this.graph,
      options: this.options,
    });
  }
}
